// extracted by css-extract-rspack-plugin
export default {"windowControls":"src-modules-desktop-pages-MainPage-components-WindowManager-components-Window-components-WindowControls-WindowControls-module__windowControls-dUfb9Q","externalLink":"src-modules-desktop-pages-MainPage-components-WindowManager-components-Window-components-WindowControls-WindowControls-module__externalLink-Y97EvE"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"windowControls\":\"src-modules-desktop-pages-MainPage-components-WindowManager-components-Window-components-WindowControls-WindowControls-module__windowControls-dUfb9Q\",\"externalLink\":\"src-modules-desktop-pages-MainPage-components-WindowManager-components-Window-components-WindowControls-WindowControls-module__externalLink-Y97EvE\"}";
        // 1793874325607
        var cssReload = require("../../../../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  